import React from "react"
import Router from "./Router"
import "../../components/@vuexy/rippleButton/RippleButton"

import "react-perfect-scrollbar/dist/css/styles.css"
import "prismjs/themes/prism-tomorrow.css"

const App = props => {
  return <Router />
}

export default App
